import axios from 'axios';

// URL da API via ngrok
const API_BASE_URL = 'https://api.certilaw.com.br/api';
//const API_BASE_URL = 'https://43e5-2804-7f0-b77d-1312-94e6-1a67-4ccf-4825.ngrok-free.app/api';

const FIXED_TOKEN = process.env.REACT_APP_AUTH_TOKEN || 'seu_token_fixo_aqui';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    proxy: false,
    headers: {
        'ngrok-skip-browser-warning': 'true',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${FIXED_TOKEN}`
    }
});


const login = async (loginOrEmail, password) => {
    console.log("Tentativa de login com:", loginOrEmail);
    
    try {
        const response = await axiosInstance.post('/login', {
            user_name: loginOrEmail,
            password,
        });

        console.log("Login realizado com sucesso.");
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Erro de resposta:", error.response.data);
            throw new Error(error.response.data.message || "Erro no login");
        } else if (error.request) {
            console.error("Erro de rede ou sem resposta:", error.request);
            throw new Error("Sem resposta do servidor ou erro de rede.");
        } else {
            console.error("Erro desconhecido:", error.message);
            throw new Error("Ocorreu um erro desconhecido.");
        }
    }
};

const getProtectedData = async () => {
    try {
        const response = await axiosInstance.get('/protected-data', {
            headers: {
                Authorization: `Bearer ${FIXED_TOKEN}`,
                'ngrok-skip-browser-warning': 'true'
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Erro ao buscar dados protegidos:", error.response.data);
        } else if (error.request) {
            console.error("Erro de rede ao buscar dados protegidos:", error.request);
        } else {
            console.error("Erro desconhecido ao buscar dados protegidos:", error.message);
        }
    }
};

const fetchTiposCertificado = async () => {
    try {
        const response = await axiosInstance.get('/CertidaoAvailable');
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar tipos de certificado:", error);
        throw error;
    }
};

export const fetchEstados = async () => {
    try {
        const response = await axiosInstance.get('/EstadosDisponiveis');
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar estados:', error);
        throw error;
    }
};

export const postCertificadosEspecificos_f = async (estado) => {
    try {
        const response = await axiosInstance.post('/filter_f', {
            filter_value: estado
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar certificados específicos:', error);
        throw error;
    }
};

export const postCertificadosEspecificos_j = async (estado) => {
    try {
        const response = await axiosInstance.post('/filter_j', {
            filter_value: estado
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar certificados específicos:', error);
        throw error;
    }
};

export const fetchUFs = async () => {
    try {
        const response = await axiosInstance.get('/FormularioEstadoSP');
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar UFs:', error);
        throw error;
    }
};

export const fetchCidadesPorUf = async (ufSelecionada) => {
    try {
        const response = await axiosInstance.get(`/FormularioCidadeSP?estado=${ufSelecionada}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar cidades:', error);
        throw error;
    }
};

export const fetchComarcasPorEstado = async (ufSelecionada) => {
   try {
     const response = await axiosInstance.get(`/comarcas?estado=${ufSelecionada}`);
     return response.data;
   } catch (error) {
     console.error('Erro ao buscar comarcas:', error);
     throw error;
   }
 };

const enviarFormularioSP = async (formData) => {
    try {
        const response = await axiosInstance.post('/ExceRobot', formData);
        return response;
    } catch (error) {
        console.error('Erro ao enviar o formulário:', error);
        throw error;
    }
};

const fetchDashboardFisico = async (payload) => {
    try {
        const response = await axiosInstance.post('/DashboardFisicoEstadual', payload);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar dados do dashboard físico:', error);
        throw error;
    }
};

const fetchDashboardJuridico = async (payload) => {
    try {
        const response = await axiosInstance.post('/DashboardJuridicoEstadual', payload);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar dados do dashboard jurídico:', error);
        throw error;
    }
};

const logout = () => {
    localStorage.removeItem('authToken')
    console.log("Logout realizado com sucesso.");
};

const getFileNameFromHeader = (headers) => {
    const disposition = headers['content-disposition'];
    if (disposition && disposition.includes('attachment')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '');
        }
    }
    return null;
};

const downloadArquivo = async (uuid) => {
    try {
        const response = await axiosInstance.post('/Downloads', { uuids: [uuid] }, {
            responseType: 'blob'
        });

        const fileName = getFileNameFromHeader(response.headers) || `${uuid}.pdf`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        handleAxiosError(error);
    }
};

const downloadArquivosZip = async (uuids) => {
    try {
        const response = await axiosInstance.post('/Downloads', { uuids }, {
            responseType: 'blob'
        });

        const fileName = getFileNameFromHeader(response.headers) || 'arquivos.zip';
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        handleAxiosError(error);
    }
};

const enviarPayloadRRA = async (payload) => {
  try {
    // POST -> https://api.certilaw.com.br/api/v1/cal_test (via axiosInstance)
    const res = await axiosInstance.post('/cal_prec', payload);
    return res; // mantém a response completa
  } catch (error) {
    if (error.response) {
      console.error("Erro na API (cal_test):", error.response.data);
    } else if (error.request) {
      console.error("Sem resposta da API (cal_test):", error.request);
    } else {
      console.error("Erro ao enviar payload RRA:", error.message);
    }
    throw error;
  }
};

const readPdf = async (file) => {
  try {
    const fd = new FormData();
    fd.append("file", file); // a rota espera 'file'

    // POST -> https://api.certilaw.com.br/api/v1/read_pdf (via axiosInstance)
    const res = await axiosInstance.post('/cal_read_pdf', fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  } catch (error) {
    if (error.response) {
      console.error("Erro na API (read_pdf):", error.response.data);
    } else if (error.request) {
      console.error("Sem resposta da API (read_pdf):", error.request);
    } else {
      console.error("Erro ao enviar PDF para read_pdf:", error.message);
    }
    throw error;
  }
};

const calConsult = async (id_user) => {
  try {
    if (!id_user) throw new Error("id_user é obrigatório");
    const res = await axiosInstance.get('/cal_consult', {
      params: { id_user },
    });
    // normaliza: pode vir array direto, {items}, {results} ou objeto único
    const data = res.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    if (Array.isArray(data?.results)) return data.results;
    if (data && typeof data === 'object') return [data];
    return [];
  } catch (error) {
    if (error.response) {
      console.error("Erro na API (cal_consult):", error.response.data);
    } else if (error.request) {
      console.error("Sem resposta do servidor (cal_consult):", error.request);
    } else {
      console.error("Erro desconhecido (cal_consult):", error.message);
    }
    throw error;
  }
};

const generateCalculoPdf = async (uuid) => {
  try {
    if (!uuid) throw new Error("uuid é obrigatório");
    const res = await axiosInstance.get(`/cal_gen_pdf/${encodeURIComponent(uuid)}`, {
      responseType: 'blob',
      headers: { Accept: 'application/pdf' },
    });
    return res.data; // <- Blob do PDF
  } catch (error) {
    if (error.response) {
      console.error("Erro na API (cal_gen_pdf):", error.response.data);
    } else if (error.request) {
      console.error("Sem resposta do servidor (cal_gen_pdf):", error.request);
    } else {
      console.error("Erro desconhecido (cal_gen_pdf):", error.message);
    }
    throw error;
  }
};

async function getResumoDashHome(id_user) {
  if (!id_user) throw new Error("id_user é obrigatório");
  // baseURL já tem /api, então aqui é só /ResumoDashHome
  return axiosInstance.get('/ResumoDashHome', {
    params: { id_user },
  });
}

const reprocessarPedido = async (id_pedido) => {
    try {
        const response = await axiosInstance.post('/reprocess', { id_pedido });
        return response.data;
    } catch (error) {
        console.error('Erro ao reprocessar pedido:', error);
        throw error;
    }
};

export default {
    login,
    getProtectedData,
    fetchTiposCertificado,
    fetchEstados,
    postCertificadosEspecificos_f,
    postCertificadosEspecificos_j,
    fetchUFs,
    fetchCidadesPorUf,
    enviarFormularioSP,
    fetchDashboardFisico,
    fetchDashboardJuridico,
    logout,
    downloadArquivo,
    downloadArquivosZip,
    fetchComarcasPorEstado,
    enviarPayloadRRA,
    readPdf,
    calConsult,
    generateCalculoPdf,
    getResumoDashHome,
    reprocessarPedido
};
